import Vue from 'vue'
import Router from 'vue-router'
import LoginPage from '../views/LoginPage'
import Dashboard from '../views/Dashboard'
import FanDetails from '../views/FanDetails'
import AcceptedMessages from '../views/AcceptedMessages'
import MyProfile from '../views/MyProfile'
import FanHistory from '../views/FanHistory'
import FanHistoryDetails from '../views/FanHistoryDetails'



Vue.use(Router)

export default new Router({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes: [{
            path: '/',
            name: 'LoginPage',
            component: LoginPage
        },

        {
            path: '/dashboard',
            name: 'Dashboard',
            component: Dashboard
        },

        {
            path: '/fan-details/:id',
            name: 'FanDetails',
            component: FanDetails
        },
        {
            path: '/accepted-message',
            name: 'AcceptedMessages',
            component: AcceptedMessages
        },
        {
            path: '/my-profile',
            name: 'MyProfile',
            component: MyProfile
        },
        {
            path: '/fan-history',
            name: 'FanHistory',
            component: FanHistory
        },
        {
            path: '/fan-historydetails/:id',
            name: 'FanHistoryDetails',
            component: FanHistoryDetails
        },
        // {
        //     path: '/celebrirty-instagram',
        //     name: 'CelebrirtyInstagram',
        //     component: CelebrirtyInstagram
        // },








    ]
})